import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'tableNameFilter', standalone: false })
export class TableNameFilterPipe implements PipeTransform {
  transform<T extends { name: string; display_name?: string }>(tables: T[], term: string): T[] {
    if (!term?.trim()) return tables;
    const q = this.normalizeVN(term);
    return (tables || []).filter(t =>
      this.normalizeVN(t.display_name || t.name).includes(q)
    );
  }
private normalizeVN(s: string | undefined | null): string {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
  }
}
